import {NotificationHelper} from "../Helper/NotificationHelper.js";

export class HandledError extends Error {
        constructor(message?: string) {
            super(message);

           NotificationHelper.Instance.error(message);
        }
    }
